import { render } from "./Footage.vue?vue&type=template&id=02586630"
import script from "./Footage.vue?vue&type=script&lang=ts"
export * from "./Footage.vue?vue&type=script&lang=ts"
script.render = render

export default script